import { Component } from '@angular/core';
import {IonicPage, ModalController, NavController, NavParams, ViewController} from 'ionic-angular';
import {API} from '../../services/api';

@IonicPage()
@Component({
  selector: 'page-filter-news',
  templateUrl: 'filter-news.html',
})
export class FilterNewsPage {
  filters = [
   
  ];
  filterSelected: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private modalCtrl: ModalController, public viewCtrl: ViewController,
              private api: API) {
  }

  ionViewDidLoad() {
    this.getCategories();
  }
  dismiss(data: string) {
    this.viewCtrl.dismiss(data);
  }
  getCategories() {
    this.api.obtenerNewsFilters().then(response => {

      console.log('RECUPERANDO FILTROS DE NOTICIAS' + JSON.stringify(response));
      this.filters = response.data.userNewsFilters;
      this.filters.forEach(item=>{
        item.selected = false;
      })
      this.resetFilters();

    }).catch(error => {
      console.error('ERROR AL RECUPERAR FILTROS' + error)
    });
  }
  resetFilters() {
    this.filterSelected = 'all';
    this.filters.map(item => {
      if (item.value == 'all') {
        item['selected'] = true;
      } else {
        item['selected'] = false;
      }
      console.log('valores de filtrados' + JSON.stringify(this.filters));
    });
  }
  selecFilter(filter) {
    this.filterSelected = filter;
    this.filters.forEach(element => {
      element.selected = false;
    });
    filter.selected = !filter.selected;
    console.log('lista ',this.filters);
  }
 
  sendFilter() {

    const data = {

    }
      this.viewCtrl.dismiss(this.filterSelected);
  }

}



// WEBPACK FOOTER //
// ./src/modals/filter-news/filter-news.ts